<template>
    <div :class="css.container">
        <div :class="css.form">
            <!-- * 标题 -->
            <div :class="css.title" class="font-variable font-bold color-1">{{ $t("DataInput") }}</div>

            <!-- * 表单 -->
            <ui-form :data="data" :rules="rules" ref="form">
                <div :class="css.cloumn">
                    <div :class="css.name">
                        <div :class="css.context">{{ $t("JobTitle") }}</div>
                    </div>

                    <ui-form-item>
                        <ui-input v-model="data.name" width="var(--size-368-336)" placeholder="ΔG Prediction" />
                    </ui-form-item>
                </div>

                <div :class="css.cloumn">
                    <div :class="css.name">
                        <div :class="css.context">{{ $t("PDBFile") }}</div>
                        <helper-modal :class="css.helper" :size="16" :icon="10" theme="grey"> {{ $t("PDBUploadDesc2") }} </helper-modal>
                    </div>

                    <ui-form-item prop="id">
                        <div :class="css.upload" @click="file?.click()">
                            <input ref="file" type="file" accept=".pdb" @change="methods.upload" hidden />
                            <ui-input v-model="name" :readonly="true" width="var(--size-368-336)" :placeholder="$t('PDBUploadDesc')" />
                            <ui-button size="small" :width="96">{{ $t("UploadFile") }}</ui-button>
                        </div>
                    </ui-form-item>
                </div>

                <div :class="css.cloumn">
                    <div :class="css.name">
                        <div :class="css.context">{{ $t("ReceptorChain") }}</div>
                        <helper-modal :class="css.helper" :size="16" :icon="10" theme="grey"> {{ $t("ReceptorChainDesc2") }} </helper-modal>
                    </div>

                    <ui-form-item prop="receptor">
                        <selector
                            v-model="data.receptor"
                            width="var(--size-368-336)"
                            @change="form?.validator(() => undefined, ['receptor'])"
                            :option="chains"
                            :disabled="data.ligand"
                            :placeholder="$t('ReceptorChainDesc')" />
                    </ui-form-item>
                </div>

                <div :class="css.cloumn">
                    <div :class="css.name">
                        <div :class="css.context">{{ $t("LigandChain") }}</div>
                        <helper-modal :class="css.helper" :size="16" :icon="10" theme="grey"> {{ $t("LigandChainDesc2") }} </helper-modal>
                    </div>

                    <ui-form-item prop="ligand">
                        <selector
                            v-model="data.ligand"
                            width="var(--size-368-336)"
                            @change="form?.validator(() => undefined, ['ligand'])"
                            :option="chains"
                            :disabled="data.receptor"
                            :placeholder="$t('LigandChainDesc')" />
                    </ui-form-item>
                </div>

                <div :class="css.cloumn">
                    <div :class="css.name">
                        <div :class="css.context">{{ $t("MutationList") }}</div>
                        <helper-modal :class="css.helper" :size="16" :icon="10" theme="grey"> {{ $t("MutationListDesc") }} </helper-modal>
                    </div>

                    <ui-form-item>
                        <ui-textarea v-model="data.mutation" width="var(--size-368-336)" placeholder="e.g. DL1Y, TH112R" />
                    </ui-form-item>
                </div>
            </ui-form>

            <!-- * 按钮组 -->
            <div :class="css.controls">
                <ui-button :class="css.reset" @click="methods.reset">{{ $t("Reset") }}</ui-button>
                <ui-button :class="css.submit" :disabled="disabled" @click="methods.submit">{{ $t("Prediction") }}</ui-button>
            </div>
        </div>
        <div :class="css.tasks">
            <!-- * 标题 -->
            <h2 :class="css.title" class="font-variable font-bold color-1">{{ $t("PredictionResults") }}</h2>
            <!-- * 内容 -->
            <div :class="css.content">
                <diagram :class="css.diagram" :data="tasks" :option="vars.option" v-if="tasks.length">
                    <template #status="{ data }">{{ useJobStatus(data.status) }}</template>
                    <template #result="{ data }">
                        <div :class="css.result" v-show="data.status == 'SUCCESS'">
                            <div :class="css.score" class="ellipsis">{{ data.result }}</div>
                            <ui-button size="small" @click="methods.next(data)" v-show="data.pdf">{{ $t("View") }}</ui-button>
                        </div>
                    </template>
                </diagram>

                <div :class="css.error" v-else>
                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/bio/dg-cover.webp" alt="" />
                    <p class="font-variable">{{ $t("DGPredictionNotData") }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiForm, UiInput, UiButton, UiFormItem, UiTextarea } from "various-ui";
//* 公共组件
import { HelperModal } from "@/components/windows";
import { Diagram } from "@/components/visualizations";
//* 私有组件
import Selector from "./components/selector/index.vue";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";

//* 组合函数
const { vars, refs, data, rules, nodes, methods, computeds } = useComposable();
const { name, tasks, chains } = refs;
const { file, form } = nodes;
const { disabled } = computeds;

//* 页面初始化
onMounted(() => methods.init());
</script>
